import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { RenderingProps, TranslationOptionsParams } from 'src/shared/shared.types';

export type S02FindALocationProps = RenderingProps<S02FindALocationFields, S02FindALocationParams>;

export type S02FindALocationFields = {
  FilterType?: Field<string>;
};

export type S02FindALocationParams = TranslationOptionsParams;
